export default "__VITE_ASSET__2740806e__"